import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';

class ErrorBoundary extends React.Component {
  constructor(props) { super(props); this.state = { error: null }; }
  static getDerivedStateFromError(e) { return { error: e }; }
  render() {
    if (this.state.error) {
      return React.createElement('div', { style: { padding: 32, fontFamily: 'monospace', color: '#c00' } },
        React.createElement('h2', null, 'Cal render error'),
        React.createElement('pre', { style: { whiteSpace: 'pre-wrap', fontSize: 13 } }, this.state.error.message + '\n\n' + this.state.error.stack)
      );
    }
    return this.props.children;
  }
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(React.createElement(ErrorBoundary, null, React.createElement(React.StrictMode, null, React.createElement(App))));
